import {
  EmailIcon,
  LinkedinIcon,
  LocationIcon,
  PhoneIcon,
  TwitterIcon,
} from "components";
import { useState } from "react";
import { useScrollReset } from "utils";

const ContactUs = () => {
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  useScrollReset();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setLoading(true);

    setSuccessMsg("");

    setErrorMsg("");

    const form = e.currentTarget;

    const formData = new FormData(form);

    const payload = {
      firstName: formData.get("firstName"),
      lastName: formData.get("lastName"),
      workEmail: formData.get("workEmail"),
      companyName: formData.get("companyName"),
      reason: formData.get("reason"),
      platform: "Website",
      message: formData.get("message"),
      storeData: formData.get("consent") === "on",
      updates: formData.get("updates") === "on",
    };

    try {
      const response = await fetch(
        "https://django-backend-prod.gridkey.in/contact-us/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-gridkey-user-role": "advisor",
          },
          body: JSON.stringify(payload),
        },
      );
      if (!response.ok) throw new Error("Failed to send message");
      await response.json();
      setSuccessMsg("Message sent successfully!");
      form.reset();
    } catch (error) {
      setErrorMsg((error as string) || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div
      className="pt-32 pb-20 w-full bg-[#111] flex flex-col md:flex-row items-start justify-center normal-gradient-bg green-gradient-bg gap-10 px-10"
      style={{
        background:
          "radial-gradient(circle,rgba(0, 40, 51, 1) 0%, rgba(0, 0, 0, 1) 60%)",
      }}
    >
      {/* LEFT SECTION */}
      <div className="max-w-[786px] flex flex-col items-center justify-center py-8 gap-6">
        <div className="flex flex-col items-start gap-10">
          <div className="flex flex-col items-start gap-4">
            <h2 className="text-white text-5xl font-medium leading-[60px]">
              Have questions? <br /> We’re here to help you!
            </h2>
            <p className="text-gray-300 text-base leading-7 max-w-[520px]">
              Get help with pricing and plans, schedule a demo, explore
              use-cases for your team, and more.
            </p>
          </div>
          {/* CONTACT DETAILS */}
          <div className="p-8 bg-[#111] rounded-2xl backdrop-blur-[50px] border border-[#1a1a1a] flex flex-col gap-8 w-full">
            <h3 className="text-white text-base font-medium">
              Contact Details
            </h3>
            <div>
              <div className="flex items-center gap-2">
                {/* <img src="/address.svg" alt="Address" /> */}
                <LocationIcon color="#6b7280" />
                <span className="text-gray-500 text-sm">Address</span>
              </div>
              <p className="text-gray-100 text-sm mt-1">
                509, International Finance Center, Fire Station, VIP Road, Vesu,
                Surat, Gujarat 395007
              </p>
            </div>
            <div>
              <div className="flex items-center gap-2">
                <EmailIcon color="#6b7280" />
                <span className="text-gray-500 text-sm">Email Id</span>
              </div>
              <p className="text-gray-100 text-sm mt-1">info@gridkey.in</p>
            </div>
            <div>
              <div className="flex items-center gap-2">
                <PhoneIcon color="#6b7280" />
                <span className="text-gray-500 text-sm">Phone No.</span>
              </div>
              <p className="text-gray-100 text-sm mt-1">+91 96386 39333</p>
            </div>
            <div className="flex gap-8 mt-2">
              <button type="button" className="cursor-pointer">
                <TwitterIcon color="#6b7280" />
              </button>
              <button type="button" className="cursor-pointer">
                <LinkedinIcon color="#6b7280" />
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* FORM SECTION */}
      <form
        onSubmit={handleSubmit}
        className="w-full md:w-[520px] p-8 bg-[#111] rounded-2xl border border-[#1a1a1a] flex flex-col gap-6"
      >
        <h3 className="text-white text-base font-medium">Let’s connect!</h3>
        <div className="flex md:flex-row flex-col gap-5">
          <div className="flex flex-col gap-2 w-full">
            <p className="text-gray-500 text-xs font-medium">
              First Name <span className="text-red-600">*</span>
            </p>
            <input
              id="firstName"
              name="firstName"
              placeholder="First Name"
              required
              className="h-14 p-3 bg-neutral-800 rounded-lg text-sm text-gray-200"
            />
          </div>
          <div className="flex flex-col gap-2 w-full">
            <p className="text-gray-500 text-xs font-medium">
              Last Name <span className="text-red-600">*</span>
            </p>
            <input
              id="lastName"
              name="lastName"
              placeholder="Last Name"
              required
              className="h-14 p-3 bg-neutral-800 rounded-lg text-sm text-gray-200"
            />
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <p className="text-gray-500 text-xs font-medium">
            Work Email <span className="text-red-600">*</span>
          </p>
          <input
            id="workEmail"
            name="workEmail"
            type="email"
            placeholder="Work Email"
            required
            className="h-14 p-3 bg-neutral-800 rounded-lg text-sm text-gray-200"
          />
        </div>
        <div className="flex flex-col gap-2">
          <p className="text-gray-500 text-xs font-medium">
            Company Name <span className="text-red-600">*</span>
          </p>
          <input
            id="companyName"
            name="companyName"
            placeholder="Company Name"
            required
            className="h-14 p-3 bg-neutral-800 rounded-lg text-sm text-gray-200"
          />
        </div>
        <div className="flex flex-col gap-2">
          <p className="text-gray-500 text-xs font-medium">
            Why I’m getting in touch? <span className="text-red-600">*</span>
          </p>
          <select
            name="reason"
            required
            className="h-14 p-3 bg-neutral-800 rounded-lg text-sm text-gray-200"
          >
            <option value="">Select Reason</option>
            <option value="pricing">Request a demo</option>
            <option value="demo">Pricing inquiry</option>
            <option value="support">Product questions</option>
            <option value="other">Support or queries</option>
          </select>
        </div>
        <div className="flex flex-col gap-2">
          <p className="text-gray-500 text-xs font-medium">
            How did you hear about Gridkey?{" "}
            <span className="text-red-600">*</span>
          </p>
          <select
            name="referral"
            required
            className="h-14 p-3 bg-neutral-800 rounded-lg text-sm text-gray-200"
          >
            <option value="">Select option</option>
            <option value="social">Google</option>
            <option value="social">LinkedIn</option>
            <option value="social">Referral</option>
            <option value="social">Event or webinar</option>
            <option value="social">ChatGPT or other AI tool</option>
            <option value="social">Other</option>
          </select>
        </div>
        <div className="flex flex-col gap-2">
          <p className="text-gray-500 text-xs font-medium">
            Message <span className="text-red-600">*</span>
          </p>
          <textarea
            name="message"
            placeholder="Message here..."
            rows={5}
            required
            className="p-4 bg-neutral-800 rounded-lg text-sm text-gray-200"
          />
        </div>
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            name="consent"
            required
            className="w-4 h-4 bg-neutral-800 rounded border-gray-600"
          />
          <p className="text-gray-300 text-xs leading-5">
            I allow Gridkey to store and use my data to process my request.
          </p>
        </div>
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            name="consent"
            required
            className="w-4 h-4 bg-neutral-800 rounded border-gray-600"
          />
          <p className="text-gray-300 text-xs leading-5">
            Keep me updated with news, insights and tips about Gridkey and
            insurance.
          </p>
        </div>
        <p className="text-gray-500 text-xs leading-5">
          Gridkey is committed to protecting and respecting your privacy, as per
          our{" "}
          <a href="/contact-us" className="underline">
            Privacy Policy
          </a>{" "}
          and{" "}
          <a href="/contact-us" className="underline">
            Cookie Policy
          </a>
          . You can unsubscribe from these communications at any time.
        </p>
        {successMsg && <p className="text-green-400 text-xs">{successMsg}</p>}
        {errorMsg && <p className="text-red-400 text-xs">{errorMsg}</p>}
        <button
          type="submit"
          disabled={loading}
          className="w-full p-4 rounded-md text-white font-medium text-sm bg-gradient-to-r from-sky-800 via-cyan-700 to-slate-500"
        >
          {loading ? "Sending..." : "Send message"}
        </button>
      </form>
    </div>
  );
};
export default ContactUs;
